module.exports = __webpack_public_path__ + "static/media/feature_3.7b575c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/feature_3.png
// module id = 1252
// module chunks = 0